import gql from 'graphql-tag'

export default gql`{
  user_roles{
    user_role_id
    description
  }
}`